export const trackGovUaModalOpen = (): void => {
  // @ts-ignore
  if (window.gtag) {
    // @ts-ignore
    window.gtag('event', 'gov_ua_modal_open', {
      event_category: 'Modal open',
      value: 1,
    });
  }
};
